<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
  <div class="modal-body">
    <div *ngIf="!simpleEdit" class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="email-input">Username (ID)<span class="required">*</span></label>
          <input (blur)="checkUserEmail($event)"
                 [disabled]="userInfo?.username"
                 class="form-control"
                 formControlName="username"
                 id="email-input"
                 placeholder="Email"
                 type="text">
        </div>
        <dp-field-error [formField]="form['username']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="firstName-input">First Name<span class="required">*</span></label>
          <input class="form-control" formControlName="firstName" id="firstName-input" placeholder="First Name"
                 type="text">
        </div>
        <dp-field-error [formField]="form['firstName']"></dp-field-error>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="lastName-input">Last Name<span class="required">*</span></label>
          <input class="form-control" formControlName="lastName" id="lastName-input" placeholder="Last Name"
                 type="text">
        </div>
        <dp-field-error [formField]="form['lastName']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="tel-input">Phone #</label>
          <input class="form-control phone-number"
                 formControlName="tel"
                 id="tel-input"
                 mask="(000) 000-0000"
                 placeholder="Phone #"
                 type="text"
          >
          <input class="form-control phone-number-ext ml-8px"
                 formControlName="ext"
                 id="ext-input"
                 placeholder="Ext."
                 type="text"
          >
        </div>
        <dp-field-error [formField]="form['tel']"></dp-field-error>
      </div>
      <div *ngIf="!simpleEdit" class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="status-input">Status<span class="required">*</span></label>
          <!--          <input type="text" class="form-control" id="status-input" formControlName="status"-->
          <!--                 placeholder="Status">-->
          <div>
            <ng-select [items]="statusGroupOptions"
                       [multiple]="false"
                       bindLabel="name"
                       bindValue="code"
                       class="form-control"
                       formControlName="status"
                       id="status-input"
                       placeholder="Select User Status">
            </ng-select>
          </div>
        </div>
        <dp-field-error [formField]="form['status']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="name-input">Company Name<span class="required">*</span></label>
          <input class="form-control" formControlName="name" id="name-input" placeholder="Company Name"
                 type="text">
        </div>
        <dp-field-error [formField]="form['name']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="contact-input">Company Phone #</label>
          <input class="form-control" formControlName="mainContact" id="contact-input" mask="(000) 000-0000"
                 placeholder="Company Phone #"
                 type="text">
        </div>
        <dp-field-error [formField]="form['mainContact']"></dp-field-error>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="mainEmail-input">Company Email<span class="required">*</span></label>
          <input class="form-control" formControlName="mainEmail" id="mainEmail-input" placeholder="Company Email"
                 type="email">
        </div>
        <dp-field-error [formField]="form['mainEmail']"></dp-field-error>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="contact-input">Company Address</label>
          <app-google-places-autocomplete [country]="country" [data]="addressData"
                                          class="w-100 mw-100 address-position"></app-google-places-autocomplete>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!simpleEdit">
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="role-input">Roles<span class="required">*</span></label>
            <!--          <input type="text" class="form-control" id="userType-input" formControlName="userType"-->
            <!--                 placeholder="User Type">-->
            <ng-select (change)="selectRoles($event);"
                       [items]="userRoleGroupOptions"
                       [multiple]="false"
                       bindLabel="name"
                       bindValue="code"
                       class="form-control"
                       formControlName="role"
                       id="role-input"
                       placeholder="Select Role"

            >
            </ng-select>
          </div>
          <dp-field-error [formField]="form['role']"></dp-field-error>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="organization-input">Organization<span
              class="required">*</span></label>
            <!--          <input type="text" class="form-control" id="company-input" formControlName="company"-->
            <!--                 placeholder="Company">-->
            <div>
              <ng-select [items]="filteredOrganizationGroupOptions"
                         [multiple]="false"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         formControlName="organization"
                         id="organization-input"
                         placeholder="Select Organization"
              >
              </ng-select>
            </div>
          </div>
          <dp-field-error [formField]="form['organization']"></dp-field-error>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="bps-input">BPs<span
              *ngIf="!Roles.b2bAdmin.includes(form['role'].value)"
              class="required">*</span></label>
            <div>
              <ng-select (change)="setBps($event)"
                         [items]="bpSelectGroup"
                         [multiple]="false"
                         [typeahead]="bpTypeahead"
                         bindLabel="label"
                         bindValue="code"
                         class="form-control"
                         formControlName="bps"
                         id="bps-input"
                         placeholder="Type Business name...">
              </ng-select>
            </div>
          </div>
        </div>
        <dp-field-error [formField]="form['bps']"></dp-field-error>
      </div>
      <div *ngIf="bps?.length > 0" class="row">
        <div class="col-md-2"></div>
        <div class="col-md-10 bp-name-container">
          <span *ngFor="let i = index; let bp of bps" class="bp-badge">
            <span class="bp-name">[{{ bp.bpNo }}] {{ bp.name }}</span>
            <span (click)="$event.preventDefault(); removeBp(bp)" class="bp-remove" tooltip="Remove BP">X</span>
          </span>

        </div>
      </div>

      <div *ngIf="[loginCompanies.Seca].includes(company)" class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="firstName-input">Employee No</label>
            <input class="form-control" formControlName="employeeNo" id="employeeNo-input" placeholder="Employee No"
                   type="text">
          </div>
          <dp-field-error [formField]="form['employeeNo']"></dp-field-error>
        </div>
      </div>

      <div class="row dateRow">
        <div class="col-md-6">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="createdAt-input">Create Date</label>
            <input class="form-control" formControlName="createdAt" id="createdAt-input" placeholder="Create Date"
                   type="text">
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative d-flex flex-row">
            <label class="detail-item-label" for="updatedAt-input">Last Login</label>
            <input class="form-control" formControlName="updatedAt" id="updatedAt-input" placeholder="Last Login"
                   type="text">
          </div>
        </div>
      </div>
      <!--      <div class="row">-->
      <!--        <div class="col-md-12">-->
      <!--          <div class="mb-3 position-relative d-flex flex-row">-->
      <!--            <label class="detail-item-label" for="name-input">Reasons</label>-->
      <!--            <input class="form-control" formControlName="rejectReason" id="reason-input" placeholder="Reason"-->
      <!--                   type="text">-->
      <!--          </div>-->
      <!--          <dp-field-error [formField]="form['rejectReason']"></dp-field-error>-->
      <!--        </div>-->
      <!--      </div>-->

    </ng-container>
  </div>

  <!--    <label for="email-input">Address</label>-->
  <!--    <span class="required"></span>-->
  <!--    <app-google-places-autocomplete [data]="userInfo?.address"></app-google-places-autocomplete>-->
</form>
<div *ngIf="!showOnboarding" class="modal-footer">
  <button (click)="submitForm($event)" class="btn btn-dark button-large" type="submit">{{ saveButtonLabel }}</button>
</div>
<div *ngIf="showOnboarding" class="modal-footer">
  <!--<button (click)="deleteRequestedUser()" class="btn btn-outline-dark button-large" type="submit">Delete</button>-->
  <button (click)="updateRequestStatus($event, 'REJECTED')" class="btn btn-outline-dark button-large" type="submit">
    Reject
  </button>
  &nbsp;&nbsp;&nbsp;
  <button (click)="updateRequestStatus($event, 'ACCEPTED')" class="btn btn-dark button-large" type="submit">Accept
  </button>
</div>
